import { ResourceDto } from "../common/ResourceDto";

export enum OperacionAdjuntoTipo
{
  Otro = 0,
  ComprobantePago = 1,
}

export type ComprobanteEditIn = {
  idOperacion?: number;
  tipo?: OperacionAdjuntoTipo;
  comentario?: string;
  adjunto?: ResourceDto;
}